import { useAtomValue, useSetAtom } from 'jotai';

import { PREORDER_STATUS_DISPLAY_LABEL, PREORDERS_TABLE_TAB } from '@ekhodealer/ekho-common';

import type { PreorderExternalStatus } from '@ekhodealer/ekho-common';

import { AccordionSection } from '@common/components/AccordionSection';
import {
	FiltersDrawerCheckboxGroup,
	type FiltersDrawerCheckboxGroupItem,
} from '@common/components/FilterGroups/FiltersDrawerCheckboxGroup';

import { statusFilterAtom, updateStatusFilterAtom } from '../../atoms/preordersAtoms';
import { usePreordersFilterFacetCounts } from '../../hooks/usePreordersFilterFacetCounts';

/**
 * Status label mapping keyed by tab value (lowercase) — derived from the shared display label map.
 * Excludes the "all" tab which has no corresponding status.
 */
const statusLabels: Record<string, string> = Object.fromEntries(
	Object.entries(PREORDERS_TABLE_TAB)
		.filter(([key]) => key !== 'ALL')
		.map(([key, tabValue]) => [
			tabValue,
			PREORDER_STATUS_DISPLAY_LABEL[key as PreorderExternalStatus],
		]),
);

/**
 * FiltersDrawerStatusSection component that provides preorder status
 * filtering options wrapped in an accordion
 */
export function FiltersDrawerStatusSection() {
	const statuses = useAtomValue(statusFilterAtom);
	const setStatuses = useSetAtom(updateStatusFilterAtom);
	const { statusCounts } = usePreordersFilterFacetCounts();

	const statusItems: FiltersDrawerCheckboxGroupItem[] = Object.entries(statusLabels).map(
		([value, label]) => ({
			value,
			label,
			count: statusCounts[value.toUpperCase()] ?? 0,
		}),
	);

	return (
		<AccordionSection title='Status'>
			<FiltersDrawerCheckboxGroup
				items={statusItems}
				value={statuses}
				onChange={setStatuses}
			/>
		</AccordionSection>
	);
}
